module.exports = __webpack_public_path__ + "static/media/bytt-no-19.aeeb8aef.mp3";